var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6628 25.3341H10.9961C5.66276 25.3341 2.99609 24.0008 2.99609 17.3341V10.6675C2.99609 5.33415 5.66276 2.66748 10.9961 2.66748H21.6628C26.9961 2.66748 29.6628 5.33415 29.6628 10.6675V17.3341C29.6628 22.6675 26.9961 25.3341 21.6628 25.3341H20.9961C20.5828 25.3341 20.1828 25.5341 19.9294 25.8675L17.9294 28.5341C17.0494 29.7075 15.6094 29.7075 14.7294 28.5341L12.7294 25.8675C12.5161 25.5741 12.0228 25.3341 11.6628 25.3341Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6593 14.6676H21.6713",
    stroke: "#1C274C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3234 14.6676H16.3354",
    stroke: "#1C274C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9894 14.6676H11.0014",
    stroke: "#1C274C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsIcon);
export default __webpack_public_path__ + "static/media/Reviews_icon.944405b1f4753130f080eb8672359611.svg";
export { ForwardRef as ReactComponent };